import api from './api';

export const getBanners = async (params) => {
  const response = await api.get('/auth/banner', { params });
  return response.data;
};

export const getBanner = async (id) => {
  const response = await api.get(`/auth/banner/${id}`);
  return response.data;
};

export const createBanner = async (data) => {
  const response = await api.post('/auth/banner', data);
  return response.data;
};

export const updateBanner = async (data) => {
  const response = await api.put('/auth/banner', data);
  return response.data;
};

export const deleteBanner = async (id) => {
  const response = await api.delete(`/auth/banner/${id}`);
  return response.data;
};
